import { IDropdownLinksState } from '../../../../types/dropdown';

export function dropdownLinkKeyToAnalyticsLabel(linkValue: keyof IDropdownLinksState): string {
  switch (linkValue) {
    case 'helpCenter':
      return 'FAQ';
    case 'developers':
      return 'ListingBuilders';
    case 'map':
      return 'Map';
    case 'realtorsForum':
      return 'AskAgents';
    case 'realtors':
      return 'ListingAgents';
    case 'cianCareer':
      return 'CianCareer';
    case 'layoutsCatalog':
      return 'LayoutListing';
    default:
      return '';
  }
}
